import {LookinChatSDK} from '../lib/lookinChatSDK';

/**
 * User entity<br>
 * For now, both ids works as composite key
 * Ie, user {id: 1, workerId: 1} and user {id: 1, workerId: null} - totally different users for system.
 * Probably this will be changed in future updates.
 *
 * @category Entity
 *
 * @remarks
 * This entity will be extended to get worker data from Sakura api.
 */
export class User {
  /** User id */
  id: number;

  /** Worker id, can be null */
  workerId: number = null;

  constructor(id: number, workerId: number = null) {
    this.id = id;
    this.workerId = workerId;
  }

  /** @return {@link WorkerStore}, that will load worker data from array or will make API call to get it<br>
   * Or, will return null if workerId is null
   *  */
  getWorker?() {
    return this.workerId ? LookinChatSDK.instance.workerApi.getWorker(this.workerId) : null;
  }
}

